import React from "react";
import clsx from "clsx";
import { DialogTitle } from "@mui/material";
import { IconButton, Icons } from "@curves/ui-base";

// 次要顏色標題
const SecondaryColorHeader = props => {
	const { className, title: propsTitle = "請設定標題", onClose: onCloseProps, children } = props;

	const handleOnClose = e => {
		onCloseProps && onCloseProps(e);
	};
	return (
		<DialogTitle className="dialog-title-header-secondary-color">
			<div className={clsx(className, onCloseProps && "dialog-title-header-secondary-color__text")}>{children || propsTitle}</div>
			{onCloseProps && (
				<div className="dialog-title-header-secondary-color__close">
					<IconButton size="large" onClick={handleOnClose}>
						<Icons.AngleDown htmlColor="#fff" />
					</IconButton>
				</div>
			)}
		</DialogTitle>
	);
};

export default SecondaryColorHeader;
